import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
} from "src/shadcn/components/ui";
import { Loader2 } from "lucide-react";
import { CSSProperties, ReactNode } from "react";
import { cn } from "src/helpers";
import RoundedButton from "../RoundedButton";
import { ClassValue } from "clsx";
import { DialogClose } from "@radix-ui/react-dialog";

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  isOpen: boolean;
  onChange?: (e: any) => void;
  onCancle?: () => void;
  onSubmit?: () => void;
  isLoading?: boolean;
  children: ReactNode;
  headerTitle: any | boolean;
  headerTitleClassName?: ClassValue;
  hideDefaultSubmit?: boolean;
  hideDefaultCancle?: boolean;
  disabledSubmitBtn?: boolean;
  disabledExtraBtn?: boolean;
  disabledCancelBtn?: boolean;
  submitBtnTitle?: string;
  showExtraBtn?: boolean;
  extrabtnTitle?: string;
  extraBtnVarient?:
    | "link"
    | "default"
    | "destructive"
    | "outline"
    | "secondary"
    | "ghost";
  extraBtnClick?: () => void;
}

const CustomeDialog_2 = ({
  isOpen,

  children,
  headerTitle,
  headerTitleClassName,

  style,
  className,
}: Props) => {
  return (
    <Dialog open={isOpen} modal>
      <DialogContent
        className={cn("sm:max-w-[525px] ", className)}
        hideClose
        style={style}
        onClick={(e: React.MouseEvent<HTMLDivElement>) => {
          e.stopPropagation();
        }}
      >
        {headerTitle && (
          <DialogHeader>
            <div className={cn(headerTitleClassName)}>{headerTitle}</div>
          </DialogHeader>
        )}
        <DialogDescription>
          <div>{children}</div>

        </DialogDescription>
      </DialogContent>
    </Dialog>
  );
};

export default CustomeDialog_2;
